import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/adminProduct", label: "Products" },
  { to: "/adminProductImages", label: "Product Images" },
  { to: "/adminOrders", label: "Orders" },
  { to: "/updateUserCartItem", label: "User Cart" },
  { to: "/categories", label: "Categories" },
  { to: "/adminUsers", label: "Users" },
  { to: "/adminWallet", label: "Wallet" },
  { to: "/adminCoupons", label: "Coupons" },
  { to: "/appSettings", label: "Settings" },
  { to: "/globalNotifications", label: "Global Notifications" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("token");
    navigate("/adminLogin");
  };

  return (
    <>
      <style>{`
        .admin-navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 18px;
          padding: 13px 24px;
          background: #6c5ce7;
          color: white;
          box-shadow: 0 2px 10px rgba(45, 35, 120, 0.18);
        }

        .admin-navbar__logo {
          flex-shrink: 0;
          font-size: 20px;
          font-weight: 700;
          white-space: nowrap;
        }

        .admin-navbar__links {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 5px;
          min-width: 0;
          flex-wrap: wrap;
        }

        .admin-navbar__link {
          color: white;
          text-decoration: none;
          padding: 8px 9px;
          border-radius: 6px;
          font-size: 14px;
          white-space: nowrap;
          transition: background-color 0.2s;
        }

        .admin-navbar__link:hover,
        .admin-navbar__link--active {
          background: rgba(255, 255, 255, 0.2);
        }

        .admin-navbar__logout {
          color: white;
          background: #dc2626;
          border: 0;
          padding: 8px 13px;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
        }

        .admin-navbar__toggle {
          display: none;
          width: 42px;
          height: 38px;
          border: 1px solid rgba(255, 255, 255, 0.45);
          border-radius: 7px;
          color: white;
          background: rgba(255, 255, 255, 0.12);
          font-size: 23px;
          line-height: 1;
          cursor: pointer;
        }

        @media (max-width: 900px) {
          .admin-navbar {
            padding: 12px 16px;
            flex-wrap: wrap;
          }

          .admin-navbar__logo {
            font-size: 18px;
          }

          .admin-navbar__toggle {
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }

          .admin-navbar__links {
            display: none;
            flex-basis: 100%;
            width: 100%;
            align-items: stretch;
            padding: 8px 0 4px;
          }

          .admin-navbar__links--open {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .admin-navbar__link,
          .admin-navbar__logout {
            width: 100%;
            box-sizing: border-box;
            padding: 11px 12px;
            text-align: left;
          }
        }
      `}</style>

      <nav className="admin-navbar">
        <div className="admin-navbar__logo">🌸 FrendRops Admin</div>

        <button
          type="button"
          className="admin-navbar__toggle"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? "×" : "☰"}
        </button>

        <div
          className={`admin-navbar__links${
            menuOpen ? " admin-navbar__links--open" : ""
          }`}
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `admin-navbar__link${
                  isActive ? " admin-navbar__link--active" : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          <button
            type="button"
            onClick={logout}
            className="admin-navbar__logout"
          >
            Logout
          </button>
        </div>
      </nav>
    </>
  );
}
